export default __webpack_public_path__ + "static/media/okikiowo.a1fb470e.png";